import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import * as mapboxgl from 'mapbox-gl';
import { isPlatformBrowser } from '@angular/common';

// declare var require: any
// const mapboxgl = require('mapbox-gl');

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
  map: mapboxgl.Map;
  @Input() lat = 47.87;
  @Input() lon = 13.55;
  @Input() name: string
  marker: mapboxgl.Marker
  styles = ['mapbox://styles/mapbox/streets-v11', 'mapbox://styles/mapbox/satellite-v9'];
  private selectedStyle = 0;
  buttonText = "Satellitenansicht"
  private platformId: string;
  private isBrowser = false;

  @Output() latEmitter = new EventEmitter<number>();
  @Output() lonEmitter = new EventEmitter<number>();

  constructor(@Inject(PLATFORM_ID) platformId: string) { 
    this.platformId = platformId;
    this.isBrowser = isPlatformBrowser(this.platformId);
  } 

  ngOnInit() {
    if (this.isBrowser) {
      if (localStorage.getItem("selectedStyle") != null) {
        this.selectedStyle = +localStorage.getItem("selectedStyle");
        // console.log("Loaded map style from local storage", localStorage.getItem("selectedStyle"));
      }

      Object.getOwnPropertyDescriptor(mapboxgl, "accessToken").set(environment.mapboxAccessToken);
      // mapboxgl.accessToken = environment.mapboxAccessToken;
        this.map = new mapboxgl.Map({
          container: 'map',
          style: this.styles[0],
          zoom: 13,
          center: [this.lon, this.lat]
      });
      // Add map controls
      this.map.addControl(new mapboxgl.NavigationControl());
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isBrowser) {
      setTimeout(() => {
        this.addMarker();
        this.map.setCenter([this.lon, this.lat]);
      }, 500);
    }
  }

  onChangeStyle() {
    if (this.isBrowser) {
      this.selectedStyle += 1;
      if (this.selectedStyle >= this.styles.length) {
        this.selectedStyle = 0;
      }
      this.map.setStyle(this.styles[this.selectedStyle]);
      localStorage.setItem("selectedStyle", this.selectedStyle.toString());
      if(this.selectedStyle == 0) {
        this.buttonText = "Satellitenansicht";
      }
      else {
        this.buttonText = "Kartenansicht";
      }
    }
  }

  addMarker() {
    if (this.marker) {
      this.marker.setLngLat([this.lon, this.lat]);
    }
    else {
      var popup = new mapboxgl.Popup({ offset: 25 }).setText(this.name);
      this.marker = new mapboxgl.Marker()
      .setLngLat([this.lon, this.lat])
      .setPopup(popup)
      .addTo(this.map);
    }
  }

}
